/* Dogwood, Sep 26 2026: menu button (hamburger) header below a chosen
   width on every device.
   Horizon shows its full desktop menu from 750px up on mouse devices
   and switches to the drawer only on touch devices or when its
   overflow list gives up. With "Never fold links into MORE" the list
   never gives up, so a laptop window or the editor's tablet preview
   between 750px and 1199px got a squeezed menu and an off-centre logo.
   Horizon's own drawer layout centres the logo, so this keeps
   #header-component in data-menu-style="drawer" whenever the window is
   narrower than the width in Theme settings > Page layout > "Menu
   button up to", and hands control back to Horizon above it.
   Loaded from layout/theme.liquid only when that setting is above 0;
   the width arrives on the script tag as data-below. */
(function () {
  var script = document.currentScript;
  var below = parseInt(script && script.getAttribute('data-below'), 10) || 0;
  if (!below || !window.matchMedia) return;

  var mq = window.matchMedia('(max-width: ' + (below - 1) + 'px)');

  function hold(h) {
    if (mq.matches && h.dataset.menuStyle !== 'drawer') h.dataset.menuStyle = 'drawer';
  }

  function start() {
    var h = document.getElementById('header-component');
    if (!h) return;
    hold(h);
    /* Horizon re-evaluates the style on load and on every resize;
       put it back whenever it flips while we are below the width. */
    new MutationObserver(function () { hold(h); })
      .observe(h, { attributes: true, attributeFilter: ['data-menu-style'] });
    /* Crossing back above the width: Horizon's resize handler runs a
       moment later and restores its own value. */
    var onChange = function (e) { if (e.matches) hold(h); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
